import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent, ResetPasswordFormComponent, CreateAccountFormComponent, ChangePasswordFormComponent } from './shared/components';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';
import { NoAuthGuard } from './core/guards/no-auth.guard';
import { DxDataGridModule, DxFormModule } from 'devextreme-angular';
import { ValidateUserComponent } from './shared/components/validate-user/validate-user.component';


const routes: Routes = [
  {
    path: 'pago-mayorista',
    loadChildren: () => import('./pages/pago-mayorista/pago-mayorista.module').then(m => m.PagoMayoristaModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'Pedidos',
    loadChildren: () => import('./pages/pedido/pedido.module').then(m => m.PedidoModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'PedidosMayorista',
    loadChildren: () => import('./pages/pedidoMayorista/pedidoMayorista.module').then(m => m.pedidoMayoristaModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'inicio',
    loadChildren: () => import('./pages/inicio/inicio.module').then(m => m.InicioModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'Produccion',
    loadChildren: () => import('./pages/produccion/produccion.module').then(m => m.ProduccionModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'Usuarios',
    loadChildren: () => import('./pages/asignacion-usuarios/asignacion-usuarios.module').then(m => m.AsignacionUsuariosModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'Productos',
    loadChildren: () => import('./pages/productos/producto.module').then(m => m.ProductoModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
 
  {
    path: 'ProductosOrden',
    loadChildren: () => import('./pages/productosOrden/productoOrden.module').then(m => m.ProductoOrdenModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'Envio',
    loadChildren: () => import('./pages/envio/envio.module').then(m => m.EnvioModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'Configuracion',
    loadChildren: () => import('./pages/configuracion/configuracion.module').then(m => m.configuracionModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'resolucion-envios',
    loadChildren: () => import('./pages/resolucion-envios/resolucion-envios.module').then(m => m.ResolucionEnviosModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'update-account/:user',
    loadChildren: () => import('./pages/cuenta/update-account/update-account.module').then(m => m.UpdateAccountModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'repartidor',
    loadChildren: () => import('./pages/repartidor/repartidor.module').then(m => m.RepartidorModule),
    canActivate: [ AuthGuard, RoleGuard ]
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'reset-password',
    component: ResetPasswordFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'create-account',
    component: CreateAccountFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'change-password/:email/:recoveryCode',
    component: ChangePasswordFormComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: 'validate-user/:recoveryCode',
    component: ValidateUserComponent,
    canActivate: [ NoAuthGuard ]
  },
  {
    path: '',
    redirectTo: 'PedidosMayorista',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'PedidosMayorista',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    DxDataGridModule,
    DxFormModule
  ],
  providers: [],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
